import { createUseStyles } from 'react-jss';
import { ITheme } from '../../theme';

type RuleNames =
  | 'dropDownItem'
  | 'checkbox'
  | 'dropDownText'
  | 'select'
  | 'selectBlock'
  | 'dateMainBlock'
  | 'checkedRadio';

export const dateWrapper = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '28px',
};
export const selectCheckBoxWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  alignSelf: 'start',
};
export const dateForm = {
  display: 'grid',
  gridTemplateColumns: '42.9% 26% 26%',
  justifyContent: 'space-between',
  gap: '16px',
  width: '100%',
};
const PREFIX = 'dateForm';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      dateMainBlock: {
        '& .MuiSvgIcon-root': {
          color: '#6CA370',
        },
      },
      select: {
        color: theme.darkGreen,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '& .MuiSvgIcon-root': {
          color: theme.green2,
        },
      },
      selectBlock: {
        color: theme.darkGreen,
      },
      dropDownItem: {
        display: 'flex',
        gap: '8px',
        '& .MuiCheckbox-root.Mui-checked': {
          color: theme.green2,
        },
        '&.MuiMenuItem-root.Mui-selected': {
          backgroundColor: 'white',
          color: theme.grey2,
        },
      },
      checkbox: {
        color: theme.grey2,
        padding: '0px',
        height: '22px',
      },
      dropDownText: {
        color: 'black',
      },
      checkedRadio: {
        color: theme.green2,
        '& .MuiSvgIcon-root': {
          color: theme.green2,
        },
      },
    }
  ),
  { name: PREFIX },
);
